import { type ReactNode } from 'react';
import { HeaderLogo } from './HeaderLogo';
import { HeaderToggle } from './HeaderToggle';
import { HeaderActions } from './HeaderActions';

interface HeaderProps {
  timerSlot?: ReactNode;
}

export function Header({ timerSlot }: HeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 h-14 bg-background border-b border-border flex items-center justify-between px-4 z-50">
      {/* Lado izquierdo: Logo + Toggle */}
      {/* Izquierda: Logo + Toggle — ancho fijo solo en desktop */}
      <div className="flex items-center gap-2 w-auto lg:w-72 shrink-0 justify-between">
        <HeaderLogo />
        <HeaderToggle />
      </div>

      {/* Lado derecho: acciones */}
      <HeaderActions timerSlot={timerSlot} />
    </header>
  );
}
